<template>
  <p class="line_item"><span class="text-uppercase">{{ label }}</span> {{ valueAmount }}</p>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "InfoItem",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
    },
    isPercentage: {
      type: Boolean,
      default: false
    },
    isBoolean: {
      type: Boolean,
      default: false
    },
    isDate: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    valueAmount() {
      if(!this.value) {
        return '--'
      }

      if(this.isPercentage) {
        return this.value + '%';
      }

      if(this.isBoolean) {
        return this.value ? 'Yes' : 'No';
      }

      if(this.isDate) {
        return dates.formatAsDate(this.value);
      }

      return this.value
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.line_item {
  margin-top: 8px;
  margin-bottom: 12px;

  span {
    display: inline-block;
    min-width: 120px;
    font-size: 0.625rem;
    color: $text-muted;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
